// extracted by mini-css-extract-plugin
module.exports = {"downloadOptions":"downloadDropdown_downloadOptions__JtL23","active":"downloadDropdown_active__fzajB"};